import { atom, swr } from '@exodus/headless-ui';
import quoteAtom from './quote.js';
import fromAssetAtom from './from-asset.js';
const feeAmountAtom = atom((get) => {
    const fromAsset = get(fromAssetAtom);
    const quote = get(swr(quoteAtom));
    return quote.data?.exchangeFeeData?.feeOpts?.fee || fromAsset.feeAsset.currency.ZERO;
});
export default feeAmountAtom;
